module.exports = __webpack_public_path__ + "img/img151_12.1c342cda.png";